// Generated by ts-to-zod
import { z } from 'zod';

export const annotationStartSchema = z.object({
  annotation: z.string(),
  sessionTimeout: z.string(),
});
